import * as reviewEffects from './reviews.effect';

export const effects = { ...reviewEffects };
